class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          this.initSlider();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
  initSlider() {
    // 100ms ka chota delay taaki browser HTML ko render kar le
    setTimeout(() => {
      const $sliderList = $(this).find('.mini-cart__navigation');

      if (typeof jQuery !== 'undefined' && $.fn.slick) {
        if ($sliderList.hasClass('slick-initialized')) {
          $sliderList.slick('unslick');
        }

        $sliderList.slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev  slider-button slider-button--prev" style="position:absolute; left:0; z-index:10; background-color: transparent; color: rgba(var(--color-foreground),.3); border:none;"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-arrow" fill="none" viewBox="0 0 14 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next slider-button slider-button--next" style="position:absolute; right:0; z-index:10; background-color: transparent; color: rgba(var(--color-foreground),.3); border:none;"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-arrow" fill="none" viewBox="0 0 14 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                arrows: true
              }
            }
          ]
        });
      } else {
        console.error("Slick Slider ya jQuery nahi mil raha hai. Kripya check karein ki dono libraries loaded hain.");
      }
    }, 100);
  }
}
customElements.define('cart-recommendations', CartRecommendations);
